
import { gsap } from 'gsap';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el             : false,
        	main            : null,

            // if false load all the hidden items, if number paginates by number
            pagination      : false,

            data_class_grid : 'grid-packery',
            data_class_item : 'item-grid'
        };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'grid_packary_load_more';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

        // get the elements to use later
        this.$a             =   this.$el.find( 'a.load-more' );
        this.$grid          =   this.$el.find( '.' + (this.$el.attr( 'data-class-grid' ) || this.options.data_class_grid)  );
        this.packery        =   this.$grid.data( 'widget' );
        this.$items         =   this.$grid.find( '.' + (this.$el.attr( 'data-class-item' ) || this.options.data_class_item)  );
        this.pagination     =   this.$el.attr( 'data-pagination' ) || this.options.pagination;


		if ( this.$a.length ){
			this.init();
		}
    }

    init(){
        if ( this.$el.hasClass( 'loaded' ) ){
            return;
        }
    	this.addEvents( true );
        this.$el.addClass('init');
	}

    addEvents( b ){
        if ( b ){
            this.$a.on( 'click', (e) => this.loadMore(e) );
        }
        else{
            this.$a.off( 'click', (e) => this.loadMore(e) );
        }
        this.active = b;
    }

    loadMore(e){
        e.preventDefault();
        if ( !this.active ){
            return;
        }
        this.active = false;

        this.main.setLoading( true );

        // calculate hidden items
        let $items = this.$grid.find( '.item-hidden' ),

            $hiddens = this.options.pagination ? $items.slice( 0, this.options.pagination ) : $items;

        //console.log( this.$items.length + ',' + $items.length + ',' + $hiddens.length );

        if ( $hiddens.length > 0 ){

            // reveal with stagger
            gsap.fromTo( $hiddens, {opacity:0}, {opacity:1, duration:0.4, stagger: 0.07} );

            // remove display none
            $hiddens.removeClass( 'item-hidden' );

            // force layout of packery
            this.packery.layout();
        }
        else{
            this.$el.addClass( 'loaded' );
        }

        $hiddens = this.$grid.find( '.item-hidden' );
        if ( $hiddens.length <= 0 ){
             this.$el.addClass( 'loaded' );
        }

        // set a delay between clcik button to avoid overlaps
        setTimeout( ()=>{
            this.main.setLoading( false );

            // check if end
            if ( $hiddens.length <= 0 ){
                 this.$el.addClass( 'end' );
                 return;
            }
            this.active=true;
        }, 700 );
    }



    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        if ( this.$a.length > 0 ){
            this.addEvents( false );
        }
    }

}